module.exports = __webpack_public_path__ + "img/go.44522de2.svg";